// @Version: 1.0.0
import { Component } from '@angular/core';
import {TRANSLATE_PATH} from '../../../shared.model';

@Component({
  selector: 'app-bank-logo-default',
  templateUrl: './bank-logo-default.component.html',
  standalone: false
})
export class BankLogoDefaultComponent {
   
   public TRANSLATE_PATH: typeof TRANSLATE_PATH = TRANSLATE_PATH;
}
